export const retry = (fn: () => boolean, count = 10, timeout = 100) => {
  if (!count) return

  const res = fn()

  if (!res) setTimeout(() => retry(fn, count - 1, timeout))
}

export function backoffFullJitter(base: number, cap: number, attempt: number) {
  const rand = Math.random() * Math.min(cap - base + 1, base * 2 ** attempt)
  return Math.floor(rand + base)
}
